<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre1" id="pgepubid00000"><span class="smcap">Jaunty Jock</span><br class="calibre2"/>
<span class="gutsmall">And Other Stories</span></h1>
<p class="c"><span class="gutsmall1">BY</span><br class="calibre3"/>
  NEIL MUNRO</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?58f6a7e7